<template>
  <div>
    <div class="is-size-6 mb-2 has-text-weight-bold">
      Pricing Summary
    </div>
    <pricing-summary-cladify 
      :estimation="estimation"
      :is-fullwidth="true"/>

    <hr/>

    <div class="is-size-6 mb-2 has-text-weight-bold">
      Detailed Pricing
    </div>

    <div 
      v-for="item in estimation.items"
      :key="item.id"
      class="mb-5">
      <div class="is-size-6 mb-2">
        Item: {{ item.architecture_name }}
      </div>
      <detailed-pricing-cladify-item
        :estimation="estimation"
        :item-id="item.id"
        :is-fullwidth="true"
        :has-footnotes="false"/>
    </div>

    <div v-if="estimation.services.length > 0">
      <div class="is-size-6 mb-2">
        Services
      </div>
      <detailed-pricing-cladify-service
        :estimation="estimation"
        :is-fullwidth="true"
        :has-footnotes="false"/>
    </div>

  </div>
</template>

<script>
import PricingSummaryCladify from '@/components/proposalmaker/PricingSummaryCladify'
import DetailedPricingCladifyItem from '@/components/proposalmaker/DetailedPricingCladifyItem'
import DetailedPricingCladifyService from '@/components/proposalmaker/DetailedPricingCladifyService'

export default {
  props: {
    estimation: {
      type: Object,
      required: true
    }
  },
  components: { 
    PricingSummaryCladify, 
    DetailedPricingCladifyItem, 
    DetailedPricingCladifyService
  }
}
</script>

<style scoped>
</style>